import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from 'src/app/service/notification/notification.service';
import { WebsocketService } from 'src/app/service/websocket/websocket.service';
import Swal from 'sweetalert2';
import { PaginationApi } from '../../domain/pagination-api';
import { Notification } from '../../domain/notification';
@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css'],
})
export class NotificationComponent implements OnInit {
  loading: boolean = true;

  notifications: PaginationApi<Notification> = new PaginationApi({
    page: 1,
    per_page: 20,
    results: [],
  });
  constructor(
    private service: NotificationService,
    private wsService: WebsocketService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.route.queryParams.subscribe((params) => {
      const { per_page, page } = params;

      Object.assign(this.notifications, {
        per_page: +(per_page ?? '20'),
        page: +(page ?? '1'),
      });
    });
  }

  ngOnInit(): void {
    this.loading = false;
    this.wsService.getNewNotification().subscribe((notification: string) => {
      this.onSearch(this.notifications.page);
    });
  }

  getNotification() {
    this.loading = true;
    this.service
      .getNotificationsPaginated(
        this.notifications.page,
        this.notifications.per_page
      )
      .subscribe({
        next: (response) => {
          Object.assign(this.notifications, response);
          this.loading = false;
        },
        error: () => (this.loading = false),
      });
  }

  setRead(id: number) {
    this.loading = true;
    this.service.updateToRead(id).subscribe((response) => {
      this.loading = false;
      Swal.fire('Salvo', 'A notificação foi marcada como lida!!', 'success');
      this.wsService.notification$.next(
        this.notifications.results.find((item) => item.id === id).title
      );
    });
  }

  onSearch(page: number = 1) {
    this.notifications.page = page;
    this.setNavigate();
  }

  setNavigate() {
    this.router.navigate(['/notification'], {
      queryParams: {
        page: this.notifications.page ?? 1,
        per_page: this.notifications.per_page ?? 10,
      },
    });
    this.getNotification();
  }

  onPerPageChanged(newPerPage: number) {
    this.notifications.per_page = newPerPage;
    this.onSearch();
  }
}
